import {
  excludedArticleTypes,
  initialArticleTilesFiltersState,
} from '@/finsight/application/CreditFlowResearch/Articles/ArticlesTile/constants';
import { IMarketTheme } from '@/finsight/domain/vo/CreditFlow/IMarketTheme';
import { ThemeSubtype, ThemeType } from '@/finsight/domain/vo/CreditFlow/Articles/themeTypes';
import { IMarketArticlesBaseFilterPayload } from '@/finsight/domain/vo/CreditFlow/Articles/IMarketArticle';
import { getFilterFromIndustry, getFilterFromSector } from '@/finsight/application/helpers';
import ISector from '@/finsight/domain/vo/ISector';
import IIndustry from '@/finsight/domain/vo/IIndustry';

export const getTilePayload = (
    filter: Partial<IMarketArticlesBaseFilterPayload>,
    includedThemeType: ThemeType,
    isConsumerOverview: boolean,
) => ({
  ...initialArticleTilesFiltersState,
  filter,
  tabParams: { includedThemeType, includedThemeSubtype: isConsumerOverview ? ThemeSubtype.abs : null },
});

export const getArticleSubTypes = (
    groupedThemesById: Record<string, IMarketTheme[]>, themeIds: string[],
): string[] => themeIds.reduce((acc, themeId) => {
  const type = groupedThemesById[themeId][0].subtype;
  return (excludedArticleTypes.includes(type) || acc.includes(type)) ? acc : [...acc, type];
}, []);

interface ISectorFilter {
  type: 'sector',
  entity: ISector,
  includedSubsectorIds?: string[],
  includedSectorIds?: string[],
}

interface IIndustryFilter {
  type: 'industry',
  entity: IIndustry,
  includedSubindustryIds?: string[],
  includedIndustryIds?: string[],
}

export type FilterConfig = ISectorFilter | IIndustryFilter;

export const createFilterConfig = (
  type: FilterConfig['type'],
  entity: FilterConfig['entity'],
): FilterConfig => <ISectorFilter | IIndustryFilter>({
  type,
  entity,
});

export const getFilterValues = (config: FilterConfig) => {
  const filterMap = {
    sector: {
      getFn: getFilterFromSector,
      getCurrentValue: (filter: Partial<IMarketArticlesBaseFilterPayload>) => (
        filter.includedSubsectorIds || filter.includedSectorIds
      ),
      getOmitKeys: () => ['includedSubsectorIds', 'includedSectorIds'],
    },
    industry: {
      getFn: getFilterFromIndustry,
      getCurrentValue: (filter: Partial<IMarketArticlesBaseFilterPayload>) => (
        filter.includedSubindustryIds || filter.includedIndustryIds
      ),
      getOmitKeys: () => ['includedSubindustryIds', 'includedIndustryIds'],
    },
  };

  return filterMap[config.type];
};
